import classNames from 'classnames';
import { FC, PropsWithChildren, ReactElement, ReactNode } from 'react';

import { IcBackIcon } from '@gem/icons';
import { IconButton, Loader } from '@gem/ui-kit';

import { ILoginLayoutAssetSrc, TLoginLayoutMessage } from '../LoginLayout.types';
import { LoginLayoutMessage } from '../LoginLayoutMessage/LoginLayoutMessage';
import styles from './LoginLayoutTemplate.styles.m.css';

interface ILoginLayoutTemplateProps {
  className?: string;
  header?: string | ReactNode;
  subtitle?: string | ReactNode | ReactElement;
  message?: TLoginLayoutMessage | null;
  isShowLogo?: boolean;
  isDarkMode?: boolean;
  isLoading?: boolean;
  logoSrc: ILoginLayoutAssetSrc;
  info?: string | ReactNode;
  onBack?(): void;
}

export const LoginLayoutTemplate: FC<PropsWithChildren<ILoginLayoutTemplateProps>> = (props) => {
  const {
    header,
    subtitle,
    message,
    isShowLogo = true,
    isDarkMode,
    isLoading,
    logoSrc,
    children,
    className,
    info,
    onBack,
  } = props;

  const containerClassName = classNames(styles.container, className);

  return (
    <div className={containerClassName}>
      {onBack && (
        <IconButton
          Icon={IcBackIcon}
          onClick={onBack}
          className={styles.buttonBack}
        />
      )}
      {isShowLogo && (
        <div className={styles.logoWrapper}>
          <img
            className={styles.logo}
            alt=""
            src={isDarkMode ? logoSrc.dark : logoSrc.light}
          />
        </div>
      )}
      <div className={styles.info}>
        {header}
        {subtitle && <h6 className={styles.subTitle}>{subtitle}</h6>}
        {message && (
          <LoginLayoutMessage
            className={styles.message}
            type={message.type}
          >
            {message.content}
          </LoginLayoutMessage>
        )}
      </div>
      {isLoading ? (
        <div className={styles.loadingWrapper}>
          <Loader
            color="brand-primary"
            size="medium"
          />
        </div>
      ) : (
        !!children && <div className={styles.content}>{children}</div>
      )}
      {info && <footer className={styles.footer}>{info}</footer>}
    </div>
  );
};
